import React, { FC, useState } from 'react';
import { cn } from '@bem-react/classname';
import { YAText } from '@ui-kit';
import { Modal, Spin } from 'antd';
import { IWorkItemCardModalProps } from './WorkItemCardModal.types';
import { formatPrice } from '@utils/number';

import Carousel from 'react-gallery-carousel';
import 'react-gallery-carousel/dist/index.css';
import { LoadingOutlined } from '@ant-design/icons';
import './WorkItemCardModal.styles.scss';
import Media from '../Media/Media';

const CnWorkItemCardModal = cn('work-item-modal');

const WorkItemCardModal: FC<IWorkItemCardModalProps> = (props) => {
  const { item, ...otherProps } = props;
  const { name, img, author, priceInfo, info, size, year, id, price, media } = item || {};
  const [isImageLoad, setIsImageLoad] = useState(false);

  return (
    <Modal
      open={!!item}
      style={{ top: 10 }}
      destroyOnClose
      footer={false}
      className={CnWorkItemCardModal('modal')}
      {...otherProps}
    >
      <div className={CnWorkItemCardModal('content')}>
        {img?.length && img?.length > 1 ? (
          <Carousel
            style={{ height: 300, width: '100%' }}
            shouldLazyLoad={false}
            hasThumbnails={false}
            canAutoPlay={false}
            hasLeftButton={false}
            hasRightButton={false}
            hasMediaButton={false}
            hasSizeButton={false}
            hasIndexBoard={false}
            hasDotButtons={'bottom'}
            images={img?.map((item) => ({ src: item }))}
          />
        ) : (
          <div className={CnWorkItemCardModal('image-container')}>
            <img
              className={CnWorkItemCardModal('image')}
              src={img?.[0]}
              alt={name}
              onLoad={() => {
                setIsImageLoad(true);
              }}
            />
            {!isImageLoad && (
              <Spin
                size={'large'}
                className={CnWorkItemCardModal('image-spin')}
                indicator={<LoadingOutlined color={'#000000'} spin />}
              />
            )}
          </div>
        )}
        <YAText text={name} type={'H2'} />
        <YAText
          text={`${price ? formatPrice(price ?? 0) + ' ₽ ' : ''}${priceInfo ?? ''}`}
          type={'H1'}
        />
        <YAText className={CnWorkItemCardModal('description')} isBold text={author} type={'H5'} />
        <div>
          <YAText className={CnWorkItemCardModal('description')} text={info} type={'description'} />
          <YAText className={CnWorkItemCardModal('description')} text={size} type={'description'} />
          <YAText className={CnWorkItemCardModal('description')} text={year} type={'description'} />
        </div>
        {media?.length && <Media media={media} id={id || ''} />}
      </div>
    </Modal>
  );
};

export default WorkItemCardModal;
